module.exports = __webpack_public_path__ + "img/icon_manejo_de_practicantes.9f7b7127.svg";